export { default } from './SecondScene';
